// Used in login-routing.module.ts

// Angular
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";

// Services/Types/Helpers
import { AuthHelper } from "#core/helpers/auth.helper";

// RXJS/Store
import { Subject } from "rxjs";

@Injectable()
export class OAuthGuardService  {
    viewAsStudent = false;
    private ngUnsubscribe = new Subject();

    constructor(private authHelper: AuthHelper, private router: Router) {}

    // used on parent routes
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const url: string = state.url;

        if (!this.authHelper.isAuthenticated()) {
            this.router.navigate(["/oauth/login"], {
                queryParams: route.queryParams,
            });
            return false;
        }

        return true;
    }
}
